// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"8a7101d3","544":"63fe5d78","952":"8a0b153a"}[chunkId] + ".chunk.css";
};